var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_9873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7653 6.91877C12.7564 7.62648 13.3945 8.02139 13.8753 8.25621C14.3691 8.49712 14.535 8.65162 14.5331 8.86708C14.5294 9.19678 14.1391 9.34231 13.7739 9.34796C13.1367 9.35786 12.7663 9.17552 12.4717 9.03761L12.2422 10.1142C12.5377 10.2507 13.0849 10.3698 13.6523 10.375C14.9842 10.375 15.8555 9.71596 15.8603 8.69414C15.8655 7.39732 14.0708 7.32554 14.0831 6.74589C14.0873 6.57013 14.2546 6.38257 14.6212 6.33488C14.8027 6.31079 15.3037 6.29235 15.8716 6.55452L16.0945 5.51286C15.7891 5.40138 15.3965 5.29463 14.9078 5.29463C13.6542 5.29463 12.7725 5.96265 12.7653 6.91877ZM18.2365 5.38436C17.9933 5.38436 17.7883 5.52656 17.6968 5.74479L15.7943 10.2985H17.1252L17.3901 9.56478H19.0164L19.1701 10.2985H20.3431L19.3195 5.38436H18.2365ZM18.4227 6.71185L18.8068 8.55716H17.7548L18.4227 6.71185ZM11.1517 5.38442L10.1026 10.2984H11.3708L12.4195 5.38429H11.1517M9.27549 5.38429L7.95542 8.72911L7.42143 5.88515C7.35877 5.56768 7.11134 5.38436 6.83656 5.38436H4.67866L4.64844 5.52705C5.09144 5.62342 5.59478 5.77884 5.89972 5.94513C6.08634 6.04672 6.13955 6.13552 6.20086 6.37692L7.21225 10.2985H8.55249L10.6073 5.38436L9.27549 5.38429Z",
    fill: "url(#paint0_linear_1748_9873)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.562437,
    y: 0.82025,
    width: 23.4658,
    height: 13.6566,
    rx: 2.57744,
    stroke: "#68767C",
    strokeWidth: 0.468625
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1748_9873",
    x1: 726.196,
    y1: 20.5662,
    x2: 740.937,
    y2: -501.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_9873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6947,
    height: 5.10077,
    fill: "white",
    transform: "translate(4.64844 5.29297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.cd6f80269c9bd7304a068e4c2230e972.svg";
export { ForwardRef as ReactComponent };